module.exports = __webpack_public_path__ + "img/kwickk-3.74c21579.gif";